let conf = {
    Production: true,
    ProductionAddress: "https://csrea.farzan.xyz/",
    test_key: "pk_test_51H7EpuChK7sxRl0HlN3ozttK5S7mf238wwMyytP7uBhOwIVdKToJASbhX60suE2NgNcc4ZQMtqOU8kkEyh38unTA008xw5ZA1O",
    live_key: "pk_live_51HJ0oPAwB3eJGbVNClinvjzFZHSGpM9JLOvsG7tet6xFttbzuHQpl4wMmbkQ7GmXWJHX0Pm4nSmR8zxPw5WCxXjn00cF8qhKNT"
}

export default conf